'use strict';

import React from 'react';
import { ObjFactory } from 'rt-sd-common';
// import DndDevMain from 'rt-sd-dnd/sgiDndDev/DndDevMain';

class UIEditor extends React.Component {
    constructor(props) {
        super(props);

        //获取浏览器地址
        // var params = this.GetRequest();
        // var params = this.props.location.state;
        this.state = {
            // uid: params.uid
        };
        // tool.sgiLogger.info(this.state.uid);
    }

    // GetRequest = function () {
    //     var url = location.search; //获取url中"?"符后的字串   
    //     var theRequest = new Object();
    //     if (url.indexOf("?") != -1) {
    //         var str = url.substr(1);
    //         var strs = str.split("&");
    //         for (var i = 0; i < strs.length; i++) {
    //             theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
    //         }
    //     }
    //     return theRequest;
    // }

    render = function () {

        var query = this.props.location.query;
        var transferData;
        if (query) {
            const uuid = query.uuid;
            transferData = JSON.parse((unescape(tool.sgiStorage.get(sgiConfig.keyPre_uuid + uuid))));
        }
        if (!transferData) transferData = {};

        let uid = transferData.uid;
        if (!uid) {
            return <div>uid为空</div>
        }
        // let ucvData = PrmFactory.getPrm(uid);
        // if (!ucvData) return null;
        var objFct = new ObjFactory(uid);
        objFct.set('@currentObjFctUID', uid);

        return (
            // <DndDevMain guid={uid} {...transferData} objFct={objFct} />
            <div>你在尝试调用dnd页面</div>
        )
    }

    // shouldComponentUpdate() {
    //     // POP 浏览器前进后退， PUSH 点击Link
    //     tool.sgiLogger.info("this.props.location.action:" + this.props.location.action);
    //     return this.props.location.action === "PUSH"
    // }
}

export { UIEditor };




// WEBPACK FOOTER //
// ./apps/project/dev/UIEditor.js